// extracted by mini-css-extract-plugin
export var cardTitle = "_cb-1";
export var commentBubble = "_cb-e";
export var commentForm = "_cb-a";
export var commentInput = "_cb-b";
export var commentLabel = "_cb-d";
export var commentPrompt = "_cb-9";
export var csatCard = "_cb-0";
export var feedbackSection = "_cb-7";
export var starDisabled = "_cb-6";
export var starEmpty = "_cb-5";
export var starFilled = "_cb-4";
export var starWrapper = "_cb-3";
export var starsContainer = "_cb-2";
export var submittedComment = "_cb-c";
export var thankYouText = "_cb-8";